/**
 * Простий — широкі діапазони та зрозумілі формулювання для непрофільних користувачів.
 * Технічний — вужчі діапазони та детальніші припущення для інженерів.
 */
export type AudienceMode = "simple" | "technical";

export const DEFAULT_AUDIENCE_MODE: AudienceMode = "simple";

export function normalizeAudienceMode(x: unknown): AudienceMode {
  return x === "technical" ? "technical" : "simple";
}

/** Множники до point-оцінки total (індикативно). */
export function estimateUncertaintyBand(mode: AudienceMode): {
  low: number;
  high: number;
} {
  return mode === "simple" ? { low: 0.48, high: 1.92 } : { low: 0.86, high: 1.14 };
}
